/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CommandLineIcon } from "@heroicons/react/24/outline";
import { getTerminalTargets } from "@/api/terminal";
import { TerminalModal } from "./TerminalModal";

/** Opens a browser console on a router or the panel host; hidden when the panel has it switched off. */
export const ConsoleButton: React.FC<{ kind: "router" | "local" | "agent"; id: string; name: string; className?: string }> = ({ kind, id, name, className }) => {
  const [open, setOpen] = useState(false);
  const { data } = useQuery({ queryKey: ["terminal-targets"], queryFn: getTerminalTargets, staleTime: 5 * 60_000, retry: false });
  if (!data?.enabled || !data.targets.some((t) => t.kind === kind && t.id === id)) return null;
  return (
    <>
      <button type="button" className={className ?? "gh-btn"} onClick={() => setOpen(true)}>
        <CommandLineIcon />
        Console
      </button>
      {open && <TerminalModal kind={kind} id={id} name={name} onClose={() => setOpen(false)} />}
    </>
  );
};
